import { ParamHistorical } from '../../../../../shared/types/param';

export interface PqrTimesParamsHistoricalProps {
    historical: ParamHistorical[];
    showHistorical?: boolean;
}

export const fieldEquivalences: { [key: string]: string } = {
    createAt: 'Fecha de creación',
    name: 'Nombre',
    status: 'Estado de la Regla',
    active: 'Activo',
    receptionChannel: 'Canal de recepción',
    typePqr: 'Tipo PQR',
    half: 'Medio',
    subtypeDp: 'Subtipo DP',
    procedure: 'Trámite',
    observation: 'Observación',
    typeDay: 'Fecha base para calculo de días',

    typeClassificationSacTime: 'Certificación',
    sacTime: 'Número de Días',

    typeClassificationFuragTime: 'Certificación',
    furagTime: 'Número de Días',
};
